import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Users, GraduationCap, Target, Film, Briefcase, ArrowRight } from 'lucide-react';
import { servicesData } from '../data/services';

const iconMap = {
  Users,
  GraduationCap,
  Target,
  Film,
  Briefcase
};

export const Services = () => {
  return (
    <section id="services" className="py-24 bg-[#061324]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-[#C9A84C] mb-4">
            What We Offer
          </div>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
            data-testid="services-title"
          >
            Services
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {servicesData.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <motion.div
                key={service.slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-[#0A2240] border border-white/10 rounded-sm p-8 card-hover-effect flex flex-col"
                data-testid={`service-card-${service.slug}`}
              >
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-[#C9A84C]/10 border border-[#C9A84C]/30 rounded-sm">
                    {Icon && <Icon className="text-[#C9A84C]" size={28} />}
                  </div>
                </div>
                <h3
                  className="text-xl md:text-2xl font-bold uppercase tracking-tight text-white mb-4"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {service.title}
                </h3>
                <p className="text-base text-[#94A3B8] leading-relaxed mb-6 flex-1" style={{ fontFamily: 'Manrope, sans-serif' }}>
                  {service.shortDescription}
                </p>
                <Link
                  to={`/services/${service.slug}`}
                  className="w-full bg-transparent border-2 border-[#C9A84C] text-[#C9A84C] px-6 py-3 rounded-sm font-bold uppercase tracking-wide text-sm hover:bg-[#C9A84C] hover:text-[#061324] transition-all flex items-center justify-center gap-2"
                  data-testid={`service-cta-${service.slug}`}
                >
                  Learn More
                  <ArrowRight size={16} />
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
